'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import ArrowRightAlt from '../../icons/ArrowRightAlt';
import { CONTENT_MHG } from '../translations/mhg';
import { FeLink } from '$/components/FeLink';
import { useClientContext } from '$/modules/context/client';

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  description = '',
  link = '',
  type = 'normal',
}) => {
  const { lang } = useClientContext();
  const staticText = CONTENT_MHG.get(lang);

  if (type === 'normal') {
    return (
      <FeLink
        href={link}
        className="card-radius flex flex-col overflow-hidden shadow bg-white"
      >
        <div className="p-4">
          <div className="mb-1 flex items-center justify-between text-gray-900 alpha-body-1">
            <p className="font-semibold">{title}</p>

            <ArrowRightAlt className="scale-50" />
          </div>
          <p className="text-gray-700 alpha-body-2">{description}</p>
        </div>
      </FeLink>
    );
  }
  if (type === 'readmore') {
    return (
      <div className="card-radius flex flex-col overflow-hidden shadow bg-white">
        <div className="flex h-full flex-col p-4">
          <div className="mb-1 flex justify-between text-gray-900 alpha-body-1">
            <p className="font-semibold">{title}</p>
          </div>
          <p className="grow text-gray-700 alpha-body-2">{description}</p>
          <div className="mt-auto flex justify-end">
            {link && (
              <FeLink
                href={link}
                title={title}
                className="mt-4 flex items-center text-primary alpha-button-1"
              >
                {staticText.read_more} <ArrowRightAlt className="scale-50" />
              </FeLink>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default InfoCard;

type InfoCardProps = {
  title: string;
  description: string;
  link: string;
  type: 'normal' | 'readmore';
};
